import { render, staticRenderFns } from "./BusinesserEditPwd.vue?vue&type=template&id=565c429b&"
import script from "./BusinesserEditPwd.vue?vue&type=script&lang=js&"
export * from "./BusinesserEditPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports